export const constants = {
  giphy_api_url: 'http://api.giphy.com/v1/gifs/search',
  // just the public api key
  giphy_api_key: 'dc6zaTOxFJmzC',
  // max number of giph records to cache
  giphy_cache_size: 800
};



/** WEBPACK FOOTER **
 ** ./client/app/shared/constants.js
 **/